define('plugin/invoice/view/InvoiceRecurringProfileInvoiceListView',['require','plugin/invoice/view/InvoiceListView'],function (require) {

    var InvoiceListView = require('plugin/invoice/view/InvoiceListView');

    /**
     * Invoice recurring profile invoices list
     *
     * @class InvoiceRecurringProfileInvoiceListView
     */
    return InvoiceListView.extend({

        template: '#invoice_recurring_profile_invoices_list_view'

    });

});
